import { IBaseAction } from '../../constants';
import moment, { Moment } from 'moment-jalaali'

export const hourRanges = [
    { label: '00-01', value: '00-01' },
    { label: '01-02', value: '01-02' },
    { label: '02-03', value: '02-03' },
    { label: '03-04', value: '03-04' },
    { label: '04-05', value: '04-05' },
    { label: '05-06', value: '05-06' },
    { label: '06-07', value: '06-07' },
    { label: '07-08', value: '07-08' },
    { label: '08-09', value: '08-09' },
    { label: '09-10', value: '09-10' },
    { label: '10-11', value: '10-11' },
    { label: '11-12', value: '11-12' },
    { label: '12-13', value: '12-13' },
    { label: '13-14', value: '13-14' },
    { label: '14-15', value: '14-15' },
    { label: '15-16', value: '15-16' },
    { label: '16-17', value: '16-17' },
    { label: '17-18', value: '17-18' },
    { label: '18-19', value: '18-19' },
    { label: '19-20', value: '19-20' },
    { label: '20-21', value: '20-21' },
    { label: '21-22', value: '21-22' },
    { label: '22-23', value: '22-23' },
    { label: '23-24', value: '23-24' },
];

export const daysOfWeek = ['sat', 'sun', 'mon', 'tue', 'wed', 'thu', 'fri'];

interface FlightNumberRange {
    min: number;
    max: number;
}

interface Register {
    airplaneType: string;
    registers: Array<string>;
}

export interface Airline {
    id: string;
    name: string;
    name_desc: string;
    users: Array<string>;
    alias: string;
    logo: string;
    flightNumberRanges: Array<FlightNumberRange>;
    registers: Array<Register>;
    incomingTerminal: string;
    outgoingTerminal: string;
}

export interface Terminal {
    airline: string;
    incomingTerminal: string;
    outgoingTerminal: string;
}

export const GET_AIRLINES_LIST = 'GET_AIRLINES_LIST';
export const GET_AIRLINES_LIST_SUCCESS = 'GET_AIRLINES_LIST_SUCCESS';
export const GET_AIRLINES_LIST_FAILURE = 'GET_AIRLINES_LIST_FAILURE';
export const GET_AIRLINES_LIST_CLEAR = 'GET_AIRLINES_LIST_CLEAR';
interface GetAirlinesListAction extends IBaseAction {
    type: typeof GET_AIRLINES_LIST | typeof GET_AIRLINES_LIST_SUCCESS | typeof GET_AIRLINES_LIST_FAILURE | typeof GET_AIRLINES_LIST_CLEAR;
    payload: {
        data: Array<Airline>;
    };
}

export interface UpdateAirlineInitialState {
    airlineId: string;
    updateBody: Airline;
}

export const UPDATE_AIRLINE = 'UPDATE_AIRLINE';
export const UPDATE_AIRLINE_SUCCESS = 'UPDATE_AIRLINE_SUCCESS';
export const UPDATE_AIRLINE_FAILURE = 'UPDATE_AIRLINE_FAILURE';
export const UPDATE_AIRLINE_CLEAR = 'UPDATE_AIRLINE_CLEAR';
interface UpdateAirlineAction extends IBaseAction {
    type:
    | typeof UPDATE_AIRLINE
    | typeof UPDATE_AIRLINE_SUCCESS
    | typeof UPDATE_AIRLINE_FAILURE
    | typeof UPDATE_AIRLINE_CLEAR;
    payload: {
        data: UpdateAirlineInitialState;
    };
}

export interface MinuteCapacity {
    range: number;
    capacity: number;
    errorMessage: string;
}

export interface HourCapacity {
    range: number;
    capacity: number;
    errorMessage: string;
}

export interface HourlyShare {
    range: number;
    share: number;
    errorMessage: string;
}

export interface SamePathCapacity {
    minMinuteDifference: number;
    capacity: number;
    errorMessage: string;
}

export interface SameRouteCapacity {
    minMinuteDifference: number;
    capacity: number;
    errorMessage: string;
}

export interface AdhanCheck {
    exitFlight: number;
    blockTime: number;
    errorMessageExitFlight: string;
    errorMessageBlockTime: string;
}

export interface StartTime {
    hour: number;
    minute: number;
}

export interface EndTime {
    hour: number;
    minute: number;
}

export interface RplOnlyTimeRange {
    checkRule: boolean;
    rplType: string;
    forbiddenTypes: string[];
    startTime: StartTime;
    endTime: EndTime;
    errorMessage: string;
}

export interface Summer {
    startDate: Moment;
    endDate: Moment;
}

export interface Winter {
    startDate: Moment;
    endDate: Moment;
}

export interface RplSeasons {
    summer: Summer;
    winter: Winter;
    summerSeason: boolean;
}

export interface TimeShare {
    airline: string;
    hourRange: string;
    days: any[];
    count: number;
}

export interface CityShare {
    airline: string;
    city: string;
    days: any[];
    count: number;
}

export interface NightStayShare {
    airline: string;
    count: number;
}

export interface RplDateTimeConstraints {
    airline: string;
    startDateTime: Moment;
    endDateTime: Moment;
}

export interface Rule {
    minuteCapacity: MinuteCapacity;
    hourCapacity: HourCapacity;
    airlineHourlyShare: HourlyShare;
    samePathCapacity: SamePathCapacity;
    sameRouteCapacity: SameRouteCapacity;
    adhanCheck: AdhanCheck;
    rplOnlyTimeRange: RplOnlyTimeRange;
    rplSeasons: RplSeasons;
    airlinesTimeShare: TimeShare[];
    airlinesCityShare: CityShare[];
    airlinesNightStayShare: NightStayShare[];
    extraFlightCurrentDay: boolean;
    rplDateTimeConstraints: RplDateTimeConstraints[];
}

export interface RulesState {
    data: Rule;
}

export const rulesInit: Rule = {
    minuteCapacity: {
        capacity: 0,
        range: 0,
        errorMessage: ''
    },
    hourCapacity: {
        capacity: 0,
        range: 0,
        errorMessage: ''
    },
    airlineHourlyShare: {
        share: 0,
        range: 0,
        errorMessage: ''
    },
    samePathCapacity: {
        capacity: 0,
        minMinuteDifference: 0,
        errorMessage: ''
    },
    sameRouteCapacity: {
        capacity: 0,
        minMinuteDifference: 0,
        errorMessage: ''
    },
    adhanCheck: {
        blockTime: 0,
        exitFlight: 0,
        errorMessageBlockTime: '',
        errorMessageExitFlight: ''
    },
    rplOnlyTimeRange: {
        checkRule: true,
        endTime: {
            hour: 0, minute: 0
        },
        startTime: {
            hour: 0, minute: 0
        },
        forbiddenTypes: [],
        rplType: '',
        errorMessage: ''
    },
    rplSeasons: {
        summer: {
            startDate: moment(),
            endDate: moment(),
        },
        winter: {
            startDate: moment(),
            endDate: moment(),
        },
        summerSeason: false,
    },
    airlinesTimeShare: [],
    airlinesCityShare: [],
    airlinesNightStayShare: [],
    extraFlightCurrentDay: false,
    rplDateTimeConstraints: []
}

export const GET_RULES = 'GET_RULES';
export const GET_RULES_SUCCESS = 'GET_RULES_SUCCESS';
export const GET_RULES_FAILURE = 'GET_RULES_FAILURE';
interface GetRules extends IBaseAction {
    type: typeof GET_RULES | typeof GET_RULES_SUCCESS | typeof GET_RULES_FAILURE;
    payload: {
        data: Rule;
    };
}

export const SET_RULES = 'SET_RULES';
export const SET_RULES_SUCCESS = 'SET_RULES_SUCCESS';
export const SET_RULES_FAILURE = 'SET_RULES_FAILURE';
export const SET_RULES_CLEAR = 'SET_RULES_CLEAR';
interface SetRulesAction extends IBaseAction {
    type:
    | typeof SET_RULES
    | typeof SET_RULES_SUCCESS
    | typeof SET_RULES_FAILURE
    | typeof SET_RULES_CLEAR;
    payload?: {
        data: Rule;
    };
}


export type RulesActionTypes = | GetRules | SetRulesAction | GetAirlinesListAction | UpdateAirlineAction;